import oAuthRepository, {OAuthRepository} from "./OAuthRepository";
import qs from "qs";

const resource = "/token";
export default {
  fetchOAuthToken(oauthRequest) {
    oauthRequest = oauthRequest ? oauthRequest : {};
    oauthRequest["client_id"] = "community-app";
    oauthRequest["grant_type"] = "password";
    oauthRequest["client_secret"] = "123";
    oAuthRepository.setContentType("application/x-www-form-urlencoded");
    return OAuthRepository.post(`${resource}`, qs.stringify(oauthRequest))
  },

  refreshOAuthToken(oauthRequest) {
    oauthRequest = oauthRequest ? oauthRequest : {};
    oauthRequest["client_id"] = "community-app";
    oauthRequest["grant_type"] = "refresh_token";
    oauthRequest["client_secret"] = "123";
    oAuthRepository.setContentType("application/x-www-form-urlencoded");
    return OAuthRepository.post(`${resource}`, qs.stringify(oauthRequest))
  }
}